import * as msal from "@azure/msal-browser";

// const clientId = '598fc2b0-2c59-4db8-8980-21a78634c7a4';
// const tenantId = 'aff3442b-5f55-409c-be77-da97b366435a';
// const apiClientId = 'e0207aef-997b-4250-b987-35e96b086eb2';

const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;
const apiClientId = process.env.REACT_APP_APICLIENT_ID;

const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: '/'
  }
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

export const acquireApiAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    /*
    * User is not signed in. Throw error or wait for user to login.
    * Do not attempt to log a user in outside of the context of MsalProvider
    */
  }
  const request = {
    scopes: [`${apiClientId}/.default`],
    account: activeAccount || accounts[0]
  };

  const authResult = await msalInstance.acquireTokenSilent(request);

  return authResult.accessToken
};

const getCurrentAccount = () => {
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  return activeAccount || accounts[0];
}

export const loggedInUserInList = (list) => {
  if (!list) {
    return false;
  }
  const upn = getCurrentAccount()?.username;
  const validUsers = list.filter(item => item.email === upn);
  if (validUsers.length > 0) {
    return true;
  }

  return false;
};

export const loggedInUserName = () => {
  return getCurrentAccount()?.name;
};

export const loggedInUserId = () => {
  return getCurrentAccount()?.idTokenClaims?.oid;
};